/* eslint-disable camelcase */
import React, { useEffect, useState, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import {
  deleteInstrument,
  getCurrency,
  getDiversification,
  getInstrumentsAll,
  getInstrumentsTBD,
  // updateInstrument,
} from '../../data/store/instruments/instrumentsActions';

import { Button, Col, Divider, Layout, Modal, Row, } from 'antd';

import { numberWithSpacesInter } from '../../helpers/formatInteger';

import Instruments from '../../components/Instruments/Instruments';
import InstrumentsTBD from '../../components/InstrumentsTBD/InstrumentsTBD';
import { ReactComponent as Edit } from '../../assets/edit-icon.svg';
import { ReactComponent as Delete } from '../../assets/delete-black-icon.svg';

import './style.scss';
import { textSort } from '../../helpers/textSort';
import CustomSortIcon from '../../components/CustomSortIcon/CustomSortIcon';

const { Header } = Layout;
export const AssetTypes = {
  ETF: 1,
  Certificate: 2,
  Fund: 3,
  Equity: 4,
  Other: 5,
  Unknown: 6,
};

// eslint-disable-next-line no-unused-vars
export const AssetTypeLabels = {
  [AssetTypes.ETF]: 'ETF',
  [AssetTypes.Certificate]: 'CERT',
  [AssetTypes.Fund]: 'FUND',
  [AssetTypes.Equity]: 'EQUITY',
  [AssetTypes.Other]: 'OTHER',
  [AssetTypes.Unknown]: 'UNKNOWN',
};

const AdminInstruments = () => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();
  const history = useHistory();

  const { assetTab } = useParams();

  const instruments = useSelector((state) => state.instrumentsReducer.instruments.list);
  const { currencyList } = useSelector((state) => state.instrumentsReducer);
  // const assets = useSelector((state) => state.instrumentsReducer.assets);
  const { diversificationList } = useSelector((state) => state.instrumentsReducer);

  const [modalDeleteVisible, setModalDeleteVisible] = useState(false);
  const [daleteKey, setDaleteKey] = useState(null);

  const [sorter, setSorter] = useState('byName');
  const [sortedList, setSortedList] = useState([]);


  const getDeletingInstrument = useMemo(() => {
    if (daleteKey) {
      return sortedList.find((i) => i.ID === daleteKey);
    }
  }, [sortedList, daleteKey]);
  useEffect(() => {
    dispatch(getInstrumentsAll({ limit: -1, offset: 0 }));
    dispatch(getInstrumentsTBD({ limit: -1, offset: 0 }));
    if (!currencyList?.length) dispatch(getCurrency());
    if (!diversificationList?.length) dispatch(getDiversification());
  }, []);

  useEffect(() => {
    if (!instruments?.length) {
      dispatch(getInstrumentsAll({ limit: -1, offset: 0 }));
    } else if (sorter && instruments?.length) {
      let newArray = [];
      sorter === 'byName'
        ? (newArray = instruments.sort((a, b) => textSort(a.name, b.name)))
        : sorter === 'byDate'
          ? (newArray = instruments.sort((a, b) => b.ID - a.ID))
          : (newArray = []);
      setSortedList([...newArray]);
    }
  }, [sorter, instruments]);

  const handleChangeSorter = (e) => {
    setSorter(e.target.value);
  };

  const hendleEdit = (id) => {
    history.push(`/quant/asset/edit-instrument/${id}`, { key: 'edit' });
  };

  const handleDelete = (key) => {
    setModalDeleteVisible(true);
    setDaleteKey(key);
  };
  const onDeleteInstrument = () => {
    dispatch(deleteInstrument(+daleteKey));
    handleCloseDelModal();
  };
  const handleCloseDelModal = () => {
    setDaleteKey(null);
    setModalDeleteVisible(false);
  };

  const getCurrencyById = (id) => {
    return currencyList?.find(el => el.id === id)?.name;
  };

  const getdiversification = (id) => {
    return diversificationList?.find(el => el.id === id)?.short_name;
  };

  const getVehicleType = (value) => {
    const type = [1, 2, 3, 4, 5, 6].includes(value) ? value : 0;
    return type ? t(AssetTypeLabels[type]) : '- - -';
  };

  const columns = [
    {
      title: t('NAME'),
      dataIndex: 'instrument',
      className: 'name',
      sorter: (a, b) => textSort(a.name, b.name),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '17%',
    },
    {
      title: t('ISIN'),
      align: 'center',
      dataIndex: 'ISIN',
      className: 'isin table-header-position-center',
      sorter: (a, b) => textSort(a.ISIN, b.ISIN),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '11%',
    },
    {
      title: t('OPERATING_MIC'),
      dataIndex: 'operating_mic',
      render: (value) => value || '- - -',
      sorter: (a, b) => textSort(a.ticker, b.ticker),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '9%',
    },
    {
      title: t('TICKER'),
      dataIndex: 'ticker',
      render: (value) => value || '- - -',
      sorter: (a, b) => textSort(a.ticker, b.ticker),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '7%',
    },
    {
      title: t('FEE'),
      dataIndex: 'fee',
      className: 'fee table-header-position-center',
      align: 'center',
      // eslint-disable-next-line react/display-name
      render: (value) => <span>{numberWithSpacesInter(value, 2)}%</span>,
      sorter: (a, b) => a.fee - b.fee,
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '6%',
    },
    {
      title: t('SHARE_PRICE'),
      align: 'right',
      dataIndex: 'latest_value',
      className: 'share-price table-header-position-right',
      render: (value) => numberWithSpacesInter(value, 2),
      sorter: (a, b) => a.latest_value - b.latest_value,
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '9%',
    },
    {
      title: t('CURRENCY'),
      align: 'center',
      dataIndex: 'currency_id',
      className: 'table-header-position-center',
      render: (value) => getCurrencyById(value),
      sorter: (a, b) => {
        if (getCurrencyById(a.currency_id) < getCurrencyById(b.currency_id)) {
          return 1;
        } else if (getCurrencyById(a.currency_id) > getCurrencyById(b.currency_id)) {
          return -1;
        } else {
          return 0;
        }
      },
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '6%',
    },
    {
      title: t('DIVERSIFICATION'),
      align: 'center',
      dataIndex: 'diversification_id',
      className: 'diversification',
      render: (value) => {
        return <span className={`diver-block 
              ${value === 28
                ? 'none'
                : value === 29
                  ? 'medi'
                  : value === 30
                    ? 'hight'
                    : ''}`
              }>
                {getdiversification(value)}
              </span>;
      },
      sorter: (a, b) => {
        if (getdiversification(a.diversification_id) < getdiversification(b.diversification_id)) {
          return 1;
        } else if (getdiversification(a.diversification_id) > getdiversification(b.diversification_id)) {
          return -1;
        } else {
          return 0;
        }
      },
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '7%',
    },
    {
      title: t('ASSET_CLASS'),
      dataIndex: 'asset_class',
      className: 'asset-class',
      render: (value, record) => {
        return (
          <>
            <p className="holdings-assetclass-cell-asset">{value}</p>
            <p className="holdings-assetclass-cell-category">
              {record.asset_category}
            </p>
          </>
        );
      },
      sorter: (a, b) => textSort(a.asset_class, b.asset_class),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '11%',
    },
    {
      title: t('INVESTMENT_VEHICLE_TYPE'),
      dataIndex: 'vehicle_type',
      className: 'asset-class',
      render: (value) => getVehicleType(value),
      sorter: (a, b) => a.vehicle_type - b.vehicle_type,
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '4%',
    },
    {
      title: t('ACTIONS'),
      align: 'center',
      dataIndex: 'operation',
      className: 'operation',
      width: '7%',
      render: (_, record) => {
        return (
        <div className="cell-button-wrapper">
          <Button
            type='text'
            onClick={() => hendleEdit(record.id)} >
            <Edit />
          </Button>
          <Button
            type='text'
            onClick={() => handleDelete(record.id)}>
            <Delete />
          </Button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div className="instrument-wrapper instrument-block-wrap">
        <div className="">
          <Header className="headerStyle suggested">
            <h1 className='suggested-portfolios-title'>{t('INSTRUMENT_MAPPING')}</h1>
            <Row className="overview-tabs-wrapper">
              <Col className="tabs-tab-wrapper" span={18}>
                <Button
                  type="text"
                  className={`overview-btn ${
                    assetTab === 'list' ? 'ant-btn-active' : ''
                  }`}
                  onClick={() => history.push('/quant/asset/list')} >
                  {t('INSTRUMENTS_TAB')}
                </Button>
                <Button
                  type="text"
                  className={`overview-btn ${assetTab === 'tbd' ? 'ant-btn-active' : ''}`}
                  onClick={() => history.push('/quant/asset/tbd')}>
                  {t('INSTRUMENTS_REQUESTS')}
                </Button>
              </Col>
            </Row>
          </Header>
            {assetTab === 'tbd'
              ? (
              <InstrumentsTBD />
                )
              : (
              <Instruments
                instruments={sortedList}
                columns={columns}
                TBD={false}
                handleChangeSorter={handleChangeSorter}
                sorter={sorter}
                assetTab={assetTab}
              />
              )}
        </div>
      </div>
      <Modal
        width={700}
        className="modal-content-paper"
        centered
        open={modalDeleteVisible}
        onCancel={handleCloseDelModal}
        footer={false}
        zIndex={1700}
      >
        <Row justify="start">
          <Col className="modal-title">{t('CONFIRM_DELETION')}</Col>
        </Row>
        <Divider className='modal-divider'/>
        <Row justify="start" className="modal-text-wrapper">
          <Col>
            <p className="modal-description">{t('TEXT_DELETION_INSTRUMENT')}</p>
            <p className="modal-name">{` ${getDeletingInstrument?.name} - - - ${getDeletingInstrument?.isin}`}</p>
          </Col>
        </Row>
        <Row justify="end" style={{marginTop: '50px'}}>
          <Col>
          <Button
            className='modal-action-btn cancel-btn'
            onClick={handleCloseDelModal}
          >
            {t('CANCEL')}
          </Button>
          <Button 
            style={{marginLeft: '8px'}} 
            className="modal-action-btn delete-btn" 
            onClick={onDeleteInstrument}>
            {t('DELETE')}
          </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default AdminInstruments;
